import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=47f88136&scoped=true"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"
import style0 from "./Application.vue?vue&type=style&index=0&id=47f88136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f88136",
  null
  
)

export default component.exports